import classNames from "classnames";
import { HTMLAttributes, ReactNode } from "react";

export const InfoItem = ({
  label,
  children,
  dir = "col",
  valueClassName = "t-text-body-sm",
  ...rest
}: {
  label: string | ReactNode;
  children: ReactNode;
  dir?: "col" | "row";
  valueClassName?: string;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={classNames("t-flex", {
        "t-flex-col t-gap-1": dir === "col",
        [rest.className || ""]: rest.className,
      })}
    >
      <span className="!t-pb-0 t-font-sans t-text-body-sm t-text-text-30">
        {label}
      </span>
      <div
        className={classNames("t-text-text-100 t-break-words", valueClassName)}
      >
        {children || "-"}
      </div>
    </div>
  );
};
